import modelOptions from './modelOptions';

export const modelsNameMapping = modelOptions.reduce(
    (acc, { model, name }) => ({ ...acc, [model]: name }),
    {}
);
